export default __webpack_public_path__ + "static/media/ArrowBackDisabled.36b986f4.webp";